import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import GuestLoginLogListPage from './GuestLoginLogList';
import GuestLoginLogModalPage from './GuestLoginLogModal';
import './GuestLoginLog.css';

@inject(
    'loginStore',
    'GuestLoginLogStore'
)
@observer
class GuestLoginLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    guestLoginLogModalOnCancel = () => {
        this.props.GuestLoginLogStore.setShowGuestLoginLogModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showGuestLoginLogModal,
            guestLoginLogTitle,
        } = this.props.GuestLoginLogStore;

        return (
            <MainContainer title={t('Guest Login Log')} menukey='guestloginlog'>
                <Modal
                    title={t(guestLoginLogTitle)}
                    visible={showGuestLoginLogModal}
                    width={800}
                    footer={null}
                    onCancel={this.guestLoginLogModalOnCancel}
                    zIndex={1000}
                >
                    <GuestLoginLogModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <GuestLoginLogListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(GuestLoginLogPage);